export const FAIXA_JUROS_TITLE = 'Juros e Repasse ao Cliente';
